import $ from 'jquery'
import * as Sentry from "@sentry/browser";

import { 
    getRedirectAfterLogin,
    logout,
    logoutAndReload, 
    openSignInModal, 
} from "./module_auth_helper";

import {
    tryPremiumModalId, 
    openModal,
} from './module_modal';

import { dataContainerSelector } from './module_common_selector';

import {reVerifyEmailAndOpenResendPopup} from "./module_checkout_helper";

import Cookies from 'js-cookie'

import { 
    handleUserLoginThenCheckout, 
    handleUserLoginLandingFreemium, 
    handleUserLoginOfferFreemium,
    handleUserLoginPageFreemium,
} from "./module_login_handler_fn";

import Toast from 'bootstrap/js/dist/toast'
import Modal from 'bootstrap/js/dist/modal'
import { close_icon_v2, thumb_up, warning_black } from "./module_svg_icons";

let UEmail = null;

const storedCredentials = {};

function sendQuizUserRef(params){
    const uid = Cookies.get('User');
    const url = apiEP('/quizsurvey')
    const data = {
        ga_id: params.gaid,
        user_id: parseInt(uid),
        lang: params.lang,
        quiz_version: params.version
    }
    $.ajax({
        method: "POST",
        url: url,
        data: JSON.stringify(data),
        dataType: 'json'
    })
}

function executeSequence(foo, loginData){
    const pls = Cookies.get(cookieNames.postLoginSequence)
    if (!pls) return
    let data = JSON.parse(pls);
    if (!data) return

    if (data && data.length){    
        data.forEach(function(item){
            let args;
            if (item['args']) {
                args = item['args'];
            }
            if(item['fn']){
                window[item['fn']](args, loginData);
            }
        });
    }
    Cookies.remove(cookieNames.postLoginSequence);
}

function bookPostLoginSequence(fName, params){
    const pls = Cookies.get(cookieNames.postLoginSequence)
    let data
    if (pls){
        data = JSON.parse(pls)
        if (!data) data = []
    }else{
        data = []
    }
    data.push({fn: fName, args: params})
    Cookies.set(cookieNames.postLoginSequence, JSON.stringify(data))

    bookPostLoginAction(cookieNames.postLoginActions.actions.executePostLoginSequence.label, 1)
}

function switchApiVersion(path, version) {
    const vBaseApiUrl = baseApiUrl.replace("/api/v1", "/api/"+version)
    return vBaseApiUrl + path;
}

function userApiCall(method, parzEP, data, okCB, errCB) {
    const ep = "/users/" + UIDg + parzEP;
    protectedApiCall(method, ep, data, okCB, errCB);
}

function userApiCallWithPromise(method, parzEP, data) {
    const ep = "/users/" + UIDg + parzEP;
    return protectedApiCallWithPromise(method, ep, data, true)
        .catch((err) => {
            const contextData = {
                apicalldata: {
                    function: "userApiCallWithPromise",
                    url: ep,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'userApiCallWithPromise fails'
            sentryAPIErrorV2(error, contextData)
            return Promise.reject(err)
        })
}

function apiRemoteCall(method, url, data, successFn, errorFn, silent, noHideSpinner) {
    silent = silent || false;
    if (!silent) {
        showSpinner();
    }
    const headers = {};
    if (LL) {
        headers["Accept-language"] = LL;
    }

    $.ajax({
        type: method,
        url: apiEP(url),
        headers: headers,
        data: JSON.stringify(data), // or JSON.stringify ({name: 'jonas'}),
        success: function (data) {
            if (successFn) {
                successFn(data);
            }
        },
        error: function (error) {
            if (errorFn) {
                errorFn(error);
            }
            hideSpinner();
            if ((typeof alertNotification !== "undefined") && (!silent)) {
                alertNotification(messages.checkout.generic_error);
            }

        },
        contentType: "application/json",
        dataType: 'json'
    }).done(function () {
        if (!noHideSpinner) {
            hideSpinner();
        }
    });
}

function apiRemoteCallWithPromise(method, url, data, silent, noHideSpinner){
    silent = silent || false;
    if (!silent) {
        showSpinner();
    }
    const headers = {};
    if (LL) {
        headers["Accept-language"] = LL;
    }
    return new Promise((resolve, reject) => {
        $.ajax({
            type: method,
            url: apiEP(url),
            headers: headers,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: 'json',
            success: function (data) {
                if (!noHideSpinner) {
                    hideSpinner();
                }
                resolve(data)
            },
            error: function (error) {
                hideSpinner();
                if ((typeof alertNotification !== "undefined") && (!silent)) {
                    alertNotification(messages.checkout.generic_error);
                }
                reject(error)
            }
        })
    })
}

// cookies START

// cookie is checked in php code
// chargebee.php getRedirectUrlAfterCheckout
export function setAfterCheckoutRedirection(url) {
    Cookies.set(cookieNames.afterCheckoutRedirect, url)
}

export function removeAfterCheckoutRedirection() {
    Cookies.remove(cookieNames.afterCheckoutRedirect)
}

export function setSkipAfterCheckoutOnboard() {
    Cookies.set(cookieNames.skipAfterCheckoutOnboard, 'true')
}

export function removeSkipAfterCheckoutOnboard() {
    Cookies.remove(cookieNames.skipAfterCheckoutOnboard)
}

export function getAfterLoginRedirection() {
    return Cookies.get('gotopostlogin')
}

export function removeAfterLoginRedirection() {
    Cookies.remove('gotopostlogin')
}

export function setAfterLoginRedirection(url) {
    Cookies.set('gotopostlogin', url)
}

function getAffiliateUser2beAssigned(){
    // return {
    //     affiliate: 'instal',
    //     uuid: 'testuuid'
    // }

    const au = Cookies.get(cookieNames.affiliateUser2beAssigned)
    if (!au) return
    return JSON.parse(au)
}

function setAffiliateUserAssigned(slug) {
    Cookies.set(cookieNames.affiliateUserAssigned, slug, {expires: 30})
}

function removeAffiliateUser2beAssigned(){
    Cookies.remove(cookieNames.affiliateUser2beAssigned)
}

function setCookieAbTestVariant(testSlug, variant) {
    Cookies.set(cookieNames.abVariantPrefix+testSlug, variant, {expires: 30})
}

function getCookieAbTestVariant(testSlug) {
    return Cookies.get(cookieNames.abVariantPrefix+testSlug)
}

function removeCookieAbTestVariant(testSlug) {
    Cookies.remove(cookieNames.abVariantPrefix+testSlug)
}

function getCookieAbTestVisitorMatch(testSlug) {
    return Cookies.get(cookieNames.abVisitorMatchPrefix+testSlug)
}

function removeCookieAbTestVisitorMatch(testSlug) {
    Cookies.remove(cookieNames.abVisitorMatchPrefix+testSlug)
}

function getCookieAbTestVid(){
    return Cookies.get(cookieNames.abVid)
}

// Used by OLD checkout flow, to come back from checkout
export function setPageThatRequestedCheckout(url) {
    Cookies.set(cookieNames.pageThatRequestedCheckout, url)
}

// Used by OLD checkout flow
export function removePageThatRequestedCheckout() {
    Cookies.remove(cookieNames.pageThatRequestedCheckout)
}

export function setLoginUrl(){
    Cookies.set(cookieNames.loginUrl, window.location.pathname, {expires: 1})
}

function getLoginUrl(){
    return Cookies.get(cookieNames.loginUrl)
}

function removeLoginUrl(){
    Cookies.remove(cookieNames.loginUrl)
}

export function setEmailVerified(data) {
    Cookies.set(cookieNames.email_verified, JSON.stringify(data), {expires: 1})
}

export function getEmailVerified() {
    const ev = Cookies.get(cookieNames.email_verified)
    if (!ev) return 
    return JSON.parse(ev)
}

// cookies END

function sendUuidDataV2(affiliateSlug, event, affUsrId){
    if(!affUsrId || !event || !affiliateSlug) return
    const url = '/analytics/affiliates/events'
    const postData = {
        "uuid": affUsrId,
        "affiliate": affiliateSlug,
        "event": event
    }

    return protectedApiCallWithPromise('POST', url, postData)
        .catch((err) => {
            const error = new Error("Error sendind affiliate data")
            error.name = "sendUuidDataV2 error"
            const contextData = {
                apicalldata:{
                    function: "sendUuidDataV2",
                    url: url,
                    method: 'POST',
                    data: JSON.stringify(postData),
                    usr: UIDg,
                    error: err
                }
            }
            sentryAPIErrorV2(error, contextData)
            throw error;
        })
}

function addBooksToFavourite(books){
    const url = uam('/users/xxx/favourites')
    protectedApiCall(
        "POST",
        url,
        {books: books},
        function(){
            books.forEach(function(){
                funnelUpdate('book_added_to_library');
            })
        },
        function(err){
            sentryAPIError(url, err, {}, 'addBooksToFavourite');
        }
    )
}

function addLikeToCategories(categories){
    const url = uam('/users/xxx/categories/feedback')
    const postData = {
        data: []
    }
    categories.forEach(element => {
        postData.data.push({category_id: element, liked: 1})
    });
    protectedApiCall(
        "POST",
        url,
        postData,
        function(resp){
            funnelUpdateWithNum('category_liked', categories.length)
        },
        function(err){
            sentryAPIError(url, err, {}, 'addLikeToCategories');
        }
    )
}

export function addSkillsToFavourites(skills){
    const url = '/favourites/skills'
    const formattedData = []
    skills.forEach(sk => {
        const formatted = {
            'skill_id': parseInt(sk),
        }
        formattedData.push(formatted)
    });
    const postData = {'data': formattedData}
    protectedApiCall(
        "POST",
        url,
        postData,
        function(resp){
            funnelUpdateWithNum('skill_liked', skills.length)
        },
        function(err){
            sentryAPIError(url, err, {}, 'addSkillsToFavourites');
        },
        true,
        false,
        'ms-1'
    )
}

function toggleEmptyCard(open) {
    const block = $(".nomatches");
    if (!block.length) return null;
    if (open) {
        block.removeClass("d-none");
    } else {
        block.addClass("d-none");
    }
}


const freeTrialDaysUpdate = function(days) {
    // free-trial-days and free-trial-30-day-date is in some translated sentencies 
    $('.free-trial-days').each(function(){
        $(this).text(days)
    })
    $('.free-trial-30-day-date').each(function(){
        $(this).text(freeTrialRefundEnd(days))
    })
}

const freeTrialDateString = function(date) {
    const lang = getLangCodeFromLang(pageLang())
    return date.toLocaleDateString(lang, { month: 'long', day: 'numeric'})
}

const freeTrialTrialEnd = function(d){
    let date = new Date(Date.now());
    date.setDate(date.getDate() + d)
    return freeTrialDateString(date)
}

const freeTrialRefundEnd = function(trialDays){
    let date = new Date(Date.now());
    date.setDate(date.getDate() + 30 + trialDays)
    return freeTrialDateString(date)
}

export function getLangCodeFromPage(){
    return getLangCodeFromLang(pageLang())
}

export const getLangCodeFromLang = function(lang){
    var out
    switch (lang) {
        case 'it':
            out = "it-IT"
            break;
        case 'en':
            out = "en-EN"
            break;
        case 'es':
            out = "es-ES"
            break;
        default:
            out = "es-ES"
    }
    return out
}

const freeTrialFunnelUpdates = function(days) {
    $('.funnel-date.f-trial-end').each(function(){
        $(this).text(freeTrialTrialEnd(days))
    })
    $('.funnel-date.f-refund-end').each(function(){
        $(this).text(freeTrialRefundEnd(days))
    })
}

const noty = function (t, message){
    let icon = ''
    let button = ''
    let duration = 5000
    let customClass = ""
    switch (t) {
        case 'success':
            icon = thumb_up
            customClass = "success"
            break
        case 'fixdanger':
            icon = warning_black
            customClass = "warn"
            button = `<button type="button" class="" data-bs-dismiss="toast" aria-label="Close">`+close_icon_v2+`</button>`
            duration = 0
            break
        default:
            customClass = "warn"
            icon = warning_black
    }
    let temp = `
    <div class="toast fade `+customClass+`" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-wrap">
            <div class="warning-icon-wrap">`+icon+`</div>
            <div class="toast-body">
                <p class="body-med">`+message+`</p>
            </div>
            `+button+`
        </div>
    </div>
    `
    const el = $(temp).appendTo('.toast-container.msg-centered')
    const domEl = el[0]
    Toast.getOrCreateInstance(domEl, {'delay': duration}).show()
    domEl.addEventListener('hidden.bs.toast', () => {
        domEl.remove()
    })
    
}

function sendDataLayer(data){
    if (data["loginRequired"]){
        if (!UIDg) {
            //Not logged in
            return false;
        }
        if (data.email && data.email !== "" && !data.email.includes("@") ){
            const contextData = {
                layerData:{
                    data: JSON.stringify(data),
                }
            }
            sentryAPIInfo("callDataLayer loginRequired email replace", contextData)
            data.email = UEM
        }
        delete data.loginRequired
    }
    if (data.email && data.email !== "" && !data.email.includes("@") ){
        const contextData = {
            layerData:{
                data: JSON.stringify(data),
            }
        }
        sentryAPIInfo("callDataLayer found wrong email", contextData)
    }
    // put dataLayer.push inside try - catch doesn't works
    dataLayer.push(data);
    return true
}

// --------- exports ---------

export const nextModalOpenVar = 'nmov';
export const nextModalOpenVarData = 'nmovd';
export const CardContainerClass = '.cme';
export const cookieNames = {
    datalayerBookPush: 'icCall',
    afterCheckoutRedirect: 'acr4b',
    planUpgradeShown: '_4b_pUS2',
    upgradeCoupon: '_4b_uc',
    planUpgradeExpires: 7,
    doNotShowDlMobile: 'doNotShowDlMobile',
    doNotShowBanner: 'doNotShowBanner',
    postLoginSequence: 'pLS',
    // remember to put global the functions used in actions
    postLoginActions: {
        name: 'pLA',
        actions: {
            setSignupMarketingPref: {
                label: 'setSignupMarketingPref',
                fn: function(val, params) {
                    if (params && params.isNew) {
                        updateUserPrefs([
                            { key: 'email_marketing', value: val ? 'yes':'no' }
                        ], function(){}, function(){});
                    }
                }
            },
            updateFunnelCheckoutViewed: {
                label: 'updateFunnelCheckoutViewed',
                fn: function(){
                    funnelUpdate('checkout_viewed');
                }
            },
            executePostLoginSequence: {
                label: 'executePostLoginSequence',
                fn: function(val, loginData){
                    executeSequence(val, loginData);
                }
            },
            doAddBooksToFavourite: {
                label: 'doAddBooksToFavourite',
                fn: function(val, params){
                    addBooksToFavourite(val)
                }
            },
            doAddCategoriesLike: {
                label: 'doAddCategoriesLike',
                fn: function(val, params){
                    addLikeToCategories(val)
                }
            },
            doAddSkillsLike: {
                label: 'doAddSkillsLike',
                fn: function(val, params){
                    addSkillsToFavourites(val)
                }
            },
            doSendQuizUserRef: {
                label: 'doSendQuizUserRef',
                fn: function(val, params){
                    sendQuizUserRef(val)
                }
            },
        }
    },
    guestSubscribing: 'gEm',
    affiliateUserAssigned: 'aua4b',
    affiliateUser2beAssigned: 'aua2b4b',
    pageThatRequestedCheckout: 'chkReqPag',
    email_verified: 'emver4b',
    loginUrl: 'logurl4b',
    skipAfterCheckoutOnboard: 'sacob4b',
    abVariantPrefix: 'ab_variant_',
    abVisitorMatchPrefix: 'ab_visitor_match_',
    abVid: 'ab_vid'
};

// use functions from module_login_handler_fn.js to avoid some circular dependencies
export const postLoginWithRedirectFuncions = {
    handleUserLoginForOfferLanding: {
        label: 'handleUserLoginForOfferLanding',
        fn: handleUserLoginThenCheckout
    },
    handleUserLoginForFreemiumLandin: {
        label: 'handleUserLoginForFreemiumLandin',
        fn: handleUserLoginLandingFreemium
    },
    handleUserLoginForFreemiumOffer: {
        label: 'handleUserLoginForFreemiumOffer',
        fn: handleUserLoginOfferFreemium
    },
    handleUserLoginForFreemiumPage: {
        label: 'handleUserLoginForFreemiumPage',
        fn: handleUserLoginPageFreemium
    }
}

// email data is also in UEM, defined in jsfunctions.twig
export function setUEmail(email){
    UEmail = email
}

export function apiEP(path) {
    return baseApiUrl + path;
}

export function apiPost(url, data, successFn, errorFn, silent, noHideSpinner) {
    apiRemoteCall('POST', url, data, successFn, errorFn, silent, noHideSpinner);
}

export function apiPostWithPromise(url, data, silent, noHideSpinner){
    return apiRemoteCallWithPromise('POST', url, data, silent, noHideSpinner);
}

export function apiPut(url, data, successFn, errorFn, silent) {
    apiRemoteCall('PUT', url, data, successFn, errorFn, silent);
}

export function managePostLoginAffiliateV2(isNew) {
    return new Promise((resolve, reject)=>{
        const affiliate2beAssignedData = getAffiliateUser2beAssigned()
        if (!affiliate2beAssignedData) { resolve(); return }

        const affiliateSlug = affiliate2beAssignedData.affiliate
        const affUsrId = affiliate2beAssignedData.uuid

        setAffiliateUserAssigned(affiliateSlug)
        removeAffiliateUser2beAssigned()

        if (isNew){
            sendUuidDataV2(affiliateSlug, 'assign', affUsrId)
                .then(()=>{
                    return sendUuidDataV2(affiliateSlug, 'signup', affUsrId)
                        .then(()=>{
                            resolve()
                        })
                        .catch(()=>{
                            resolve()
                        })
                })
                .catch(()=>{
                    resolve()
                })
        }else{
            sendUuidDataV2(affiliateSlug, 'assign', affUsrId)
            .then(()=>{
                resolve()
            })
            .catch(()=>{
                resolve()
            })
        }
    })
}

function setNewABTestVariant(userData){
    // variant already set
    if (getABTestVariant()) return false

    if (!abEnter) return false

    // Normally a new page is loaded after login, and variant cookie is setted in php module
    // If redirectAfterLogin is false, we have to set cookie here
    // and in the 'userLogged' listener we can use getABTestVariant()
    if (!getRedirectAfterLogin()) return true

    if(abForNew && userData.is_new) return true
    
    return false
}

// same format as php uniqid used in Abtest::getVid
function generateABTestVid(){
    const now = Date.now().toString(16)
    const random = Math.random().toString(16).substring(2, 10)
    const extra = Math.random().toFixed(8).substring(2)
    return `webVis_${now}${random}.${extra}`
}

function getABTestVid(){
    // This value should always be setted in php
    const vidFromCookie = getCookieAbTestVid()
    if (vidFromCookie) return vidFromCookie

    return generateABTestVid()
}

export function gotABTest(){
    return typeof active_abtest === 'undefined' || active_abtest == "" ? false : true
}

export function getABTestVariant(){
    return getCookieAbTestVariant(active_abtest)
}

export function saveABTestVariant(variant){
    return setCookieAbTestVariant(active_abtest, variant)
}

export function removeABTestVariant(){
    return removeCookieAbTestVariant(active_abtest)
}

export function getAbTestVisitorMatch(){
    return getCookieAbTestVisitorMatch(active_abtest)
}

export function removeAbTestVisitorMatch(){
    return removeCookieAbTestVisitorMatch(active_abtest)
}

export function manageABVisitorMatch(){
    return new Promise((resolve, reject)=>{
        if (!gotABTest()) {
            resolve()
            return
        }

        if (getAbTestVisitorMatch()){
            const url = '/abtests/matches'
            const postData = {
                vid: getABTestVid()
            }
            return protectedApiCallWithPromise('POST', url, postData)
                .then(()=>{
                    removeAbTestVisitorMatch()
                    resolve()
                })
                .catch((err)=>{
                    const contextData = {
                        apicalldata:{
                            function: "manageABVisitorMatch",
                            url: url,
                            method: 'POST',
                            data: JSON.stringify(postData),
                            status: err.status,
                            response: err.responseJSON,
                            uid: UIDg,
                        }
                    }
                    const error = new Error('Error matching user')
                    error.name = 'manageABVisitorMatch fail'
                    sentryAPIErrorV2(error, contextData)
                    reject(err)
                })
        }
        resolve()
    })
}

export function manageABVisitorMatchForSlug(testSlug){
    return new Promise((resolve, reject) => {
        if (!testSlug) {
            resolve()
            return
        }

        if (getCookieAbTestVisitorMatch(testSlug)){
            const url = '/abtests/matches'
            const postData = {
                vid: getABTestVid()
            }
            return protectedApiCallWithPromise('POST', url, postData)
                .then(() => {
                    removeCookieAbTestVisitorMatch(testSlug)
                    resolve()
                })
                .catch((err) => {
                    const contextData = {
                        apicalldata:{
                            function: "manageABVisitorMatchForSlug",
                            url: url,
                            method: 'POST',
                            data: JSON.stringify(postData),
                            status: err.status,
                            response: err.responseJSON,
                            uid: UIDg,
                        }
                    }
                    const error = new Error('Error matching user')
                    error.name = 'manageABVisitorMatchForSlug fail'
                    sentryAPIErrorV2(error, contextData)
                    reject(err)
                })
        }
        resolve()
    })
}

// Scans all cookies at login time for offer-abtest match flags, 
// avoiding reliance on page-level slug which may be empty if login happens on a different page than the tested offer.
export function manageAllOfferABVisitorMatches(){
    try {
        const prefix = cookieNames.abVisitorMatchPrefix
        const allCookies = Cookies.get()
        const slugs = Object.keys(allCookies)
            .filter(name => name.startsWith(prefix) && allCookies[name] === 't')
            .map(name => name.slice(prefix.length))
            .filter(slug => slug !== active_abtest)
        return Promise.all(slugs.map(slug => manageABVisitorMatchForSlug(slug)))
    } catch(err) {
        return Promise.reject(err)
    }
}

// manage only some case here, see setNewABTestVariant
export function retriveAndSaveABVariantDuringLogin(userData){
    return new Promise((resolve, reject) => {
        if (!gotABTest()) {
            resolve()
            return
        }
        
        // conditions here
        if (!setNewABTestVariant(userData)) {
            resolve()
            return
        }
        
        const ep = persUrl('/abtests/variants');
        const vid = getABTestVid()
        const postData = {"ab": active_abtest, "platform": "web", "vid": vid}
        return protectedApiCallWithPromise('POST', ep, postData)
            .then((data)=>{
                saveABTestVariant(data.v)
                resolve()
            })
            .catch((err)=>{
                const contextData = {
                    apicalldata: {
                        function: "retriveAndSaveABVariantDuringLogin",
                        url: ep,
                        method: 'POST',
                        data: JSON.stringify(postData),
                        status: err.status,
                        response: err.responseJSON,
                    }
                }
                const error = new Error('Error retriving checkoutVariant')
                error.name = 'retriveAndSaveABVariantDuringLogin fail'
                sentryAPIErrorV2(error, contextData)
                reject(err)
            })
    })
}

export function uam(url) {
    const u = Cookies.get('User');
    if (u && url) {
        return url.replace('xxx', u);
    }
    return false;
}

export function funnelUpdateWhenAvailable(evName){
    if (UIDg && (parseInt(UIDg, 10) > 0)){
        funnelUpdate(evName);
    } else {
        bookPostLoginSequence('funnelUpdate', evName);
    }
}

export function bookPostLoginAction(action, value){
    const pla = Cookies.get(cookieNames.postLoginActions.name)
    let data
    if (pla){
        data = JSON.parse(pla);
        if (!data) data = {}
    }else{
        data = {}
    }
    data[action] = value;
    Cookies.set(cookieNames.postLoginActions.name, JSON.stringify(data));
}

export function updateUserPrefs(prefs, okCB, errCB){
    userApiCall('PUT', '/prefs', {prefs: prefs}, okCB, errCB)
}

export function updateUserPrefsV2(prefs){
    return userApiCallWithPromise('PUT', '/prefs', {prefs: prefs})
}

export function sentryAPIError(ep, error, data, funcName, fireException) {
    fireException = fireException || false;
    const info = {
        err: error,
        ep: ep,
        data: data
    };
    Sentry.captureMessage(funcName + ' failed: ' + JSON.stringify(info));
    if (fireException) {
        Sentry.captureException(error);
    }
}

export function sentryAPIErrorV2(err, contextData) {
    // contextData should be an object {contextxName: {..DATA..}}
    Sentry.captureException(err, {contexts: contextData});
}

export function sentryAPIInfo(msg, contextData, fingerprint) {
    // contextData should be an object {contextxName: {..DATA..}}
    // fingerprint should be an array of strings
    const captureContext = {contexts: contextData}
    if (fingerprint){
        captureContext.fingerprint = fingerprint
    }
    // https://docs.sentry.io/platforms/javascript/guides/connect/configuration/apis/#captureMessage
    Sentry.captureMessage(msg, captureContext)
}

export function funnelUpdate(ev) {
    const payload = {
        src: __PARAMS.funnelSource,
        event_type: ev
    }
    const utm = Cookies.get(__PARAMS.utmDataCookieName)
    if (utm){
        const utmp = JSON.parse(utm);
        Object.assign(payload, utmp);
    }
    protectedApiCall(
        'POST',
        '/analytics/userfunnel/event',
        {event: payload}
    );
}

export function funnelUpdateWithNum(ev, num) {
    const payload = {
        src: __PARAMS.funnelSource,
        event_type: ev,
        num: num
    }
    const utm = Cookies.get(__PARAMS.utmDataCookieName)
    if (utm){
        const utmp = JSON.parse(utm)
        Object.assign(payload, utmp)
    }
    protectedApiCall(
        'POST',
        '/analytics/userfunnel/event',
        {event: payload}
    )
}

export function confirmEmailVerified(obj) {
    let ep = '/auth/firebase/' + obj.uid + '/email_verify/' + obj.code
    apiRemoteCall('GET', ep, null,
        function (resp) {
            openModal("#welcomeTo4booksModal", "confirmEmailVerified")
        },
        function (err) {
            // TODO
            // error to Sentry
            openModal("#requestProblemTryLogoutModal", "confirmEmailVerified")
        }
    )
}

export function reSubscribe(where, subId) {
    if (reactivatingSubscription) {
        return false;
    }
    reactivatingSubscription = 1;
    const ep = "/users/" + UIDg + "/subscription/cb/reactivate";
    protectedApiCall('PUT', ep,
        {subscription_id: subId},
        function (response) {
            // TODO 
            // can we call dataLayer.push(data) right now?
            requestDatalayerPushNextPage({
                event: "UserReactivatedAutomaticRenewal",
                userId: luData.id,
                email: luData.email,
                where: where
            });
            location.reload();
        }, function (e) {
            const error = e['responseJSON'] || null;
            if (error) {
                if (error['message']) {
                    if (error.message === 'subscription-not-inactive') {
                        alertNotification(messages.subscriptionNotInactive);
                        return;
                    }
                    if (error.message === 'subscription-non-chargebee') {
                        alertNotification(messages.subscriptionNonChargebee);
                        return;
                    }
                }
            }
            //Probably expired token
            alertNotification(messages.renewFailedGeneric);
        })
}

export function protectedApiCall(method, url, data, okCallback, koCallback, silent, forceLogout, version) {
    let defaultVersion = "v1";
    if (typeof silent === 'undefined') silent = true
    forceLogout = forceLogout || false;
    version = version || defaultVersion;
    let bearer = Cookies.get('Authorization');
    let refreshToken = Cookies.get('Refresh');
    if (storedCredentials['bearer']){
        //One time usage to prevent async problems
        bearer = storedCredentials.bearer;
        delete(storedCredentials.bearer);
    }
    if (storedCredentials['refreshToken']){
        refreshToken = storedCredentials.refreshToken;
        delete(storedCredentials.refreshToken);
    }

    if (!bearer) {
        logoutAndReload()
        return false;
    }
    if (!silent) showSpinner();
    let epUrl = apiEP(url)
    if (version !== defaultVersion){
        epUrl = switchApiVersion(url, version)
    }

    let requestData = null
    if (method != 'GET'){
        requestData = JSON.stringify(data)
    }

    $.ajax({
        method: method,
        headers: {
            "Authorization": 'Bearer ' + bearer, 
            "Accept-language": LL,
            "x-client-type": "web",
            "x-client-version": JS_VERSION
        },
        url: epUrl,
        data: requestData,
        dataType: 'json',
        statusCode: {
            410: function (response) {
                //Expired token
                if (forceLogout) {
                    //Avoid looping
                    logoutAndReload()
                }
                const refreshUrl = apiEP('/auth/refresh?preventCache='+Date.now())
                const refreshData = JSON.stringify({refresh_token: refreshToken})
                $.ajax({
                    method: 'POST',
                    headers: {"Authorization": 'Bearer ' + bearer},
                    url: refreshUrl,
                    data: refreshData,
                    dataType: 'json',
                    success: function (retData) {
                        //Set new Cookie
                        Cookies.set('Authorization', retData.access_token);
                        Cookies.set('Refresh', retData.refresh_token);
                        storedCredentials.bearer = retData.access_token;
                        storedCredentials.refreshToken = retData.refresh_token;

                        //Recall
                        protectedApiCall(method, url, data, okCallback, koCallback, silent, true);
                    },
                    error: function (err) {
                        const error = new Error("auth refresh request error")
                        error.name = "Token refresh error"
                        const contextData = {
                            apicalldata:{
                                function: "protectedApiCall",
                                url: refreshUrl,
                                method: 'POST',
                                data: refreshData,
                                bearer: bearer,
                                errorStatus: err.status,
                                errorResponse: err.responseJSON,
                            }
                        }
                        sentryAPIErrorV2(error, contextData)
                        logoutAndReload()
                    }
                })
            },
            401: function (){
                const error = new Error("protectedApiCall got 401")
                error.name = "protectedApiCall Unauthorized"
                const contextData = {
                    apicalldata:{
                        function: "protectedApiCall",
                        url: url,
                        version: version,
                        method: method,
                        data: JSON.stringify(data),
                        bearer: bearer,
                    }
                }
                sentryAPIErrorV2(error, contextData)
                logoutAndReload()
            }
        },
        success: function (data) {
            if (okCallback) okCallback(data);
        },
        error: function (err) {
            if (err['status']) {
                if (err['status'] === 410) {
                    //Already managed
                    return;
                }
            }
            if ((typeof alertNotification !== "undefined") && (!silent)) {
                alertNotification(messages.verificationEmail.errorDescription);
            }
            if (!silent) hideSpinner();
            if (koCallback) koCallback(err);
        }
    }).done(function () {
        if (!silent) hideSpinner();
    });
}

export function protectedApiCallWithPromise(method, url, data, silent, forceLogout, version) {
    return new Promise((resolve, reject) => {
        let defaultVersion = "v1";
        if (typeof silent === 'undefined'){
            silent = true
        }
        forceLogout = forceLogout || false;
        version = version || defaultVersion;
        let bearer = Cookies.get('Authorization');
        let refreshToken = Cookies.get('Refresh');
        if (storedCredentials['bearer']){
            //One time usage to prevent async problems
            bearer = storedCredentials.bearer;
            delete(storedCredentials.bearer);
        }
        if (storedCredentials['refreshToken']){
            refreshToken = storedCredentials.refreshToken;
            delete(storedCredentials.refreshToken);
        }

        if (!bearer) {
            logoutAndReload()
            reject("No auth provided")
            return;
        }
        if (!silent) {
            showSpinner();
        }
        let epUrl = apiEP(url)
        if (version !== defaultVersion){
            epUrl = switchApiVersion(url, version)
        }

        const doneActions = function(){
            hideSpinner()
        }

        let requestData = null
        if (method != 'GET'){
            requestData = JSON.stringify(data)
        }

        $.ajax({
            method: method,
            headers: {
                "Authorization": 'Bearer ' + bearer, 
                "Accept-language": LL,
                "x-client-type": "web",
                "x-client-version": JS_VERSION
            },
            url: epUrl,
            data: requestData,
            dataType: 'json',
            success: function (data) {
                doneActions()
                resolve(data)
            },
            error: function (err, textStatus) {
                if (err['status']) {
                    if (err['status'] === 410) {
                        if (forceLogout) {
                            //Avoid looping
                            reject (new Error("Too much request with 410 response"))
                            // remove logout?
                            logout()
                            return
                        }
                        const refreshUrl = apiEP('/auth/refresh?preventCache='+Date.now())
                        const refreshData = JSON.stringify({refresh_token: refreshToken})
                        $.ajax({
                            method: 'POST',
                            headers: {"Authorization": 'Bearer ' + bearer},
                            url: refreshUrl,
                            data: refreshData,
                            dataType: 'json',
                            success: function (retData) {
                                //Set new Cookie
                                Cookies.set('Authorization', retData.access_token);
                                Cookies.set('Refresh', retData.refresh_token);
                                storedCredentials.bearer = retData.access_token;
                                storedCredentials.refreshToken = retData.refresh_token;
        
                                //Recall
                                protectedApiCallWithPromise(method, url, data, silent, true, version)
                                    .then((data)=>{
                                        resolve(data)
                                    })
                                    .catch((err)=>{
                                        const error = new Error("Api call error")
                                        error.name = "Api call error after Token refresh"
                                        const contextData = {
                                            apicalldata:{
                                                function: "protectedApiCallWithPromise",
                                                url: url,
                                                method: method,
                                                data: JSON.stringify(data),
                                                bearer: bearer,
                                                errorStatus: err.status,
                                                errorResponse: err.responseJSON,
                                            }
                                        }
                                        sentryAPIErrorV2(error, contextData)
                                        reject(err)
                                    })
                                    .finally(()=>{
                                        doneActions()
                                    })
                            },
                            error: function (err) {
                                const error = new Error("auth refresh request error")
                                error.name = "Token refresh error"
                                const contextData = {
                                    apicalldata:{
                                        function: "protectedApiCallWithPromise",
                                        url: refreshUrl,
                                        method: 'POST',
                                        data: refreshData,
                                        bearer: bearer,
                                        errorStatus: err.status,
                                        errorResponse: err.responseJSON,
                                    }
                                }
                                sentryAPIErrorV2(error, contextData)
                                doneActions()
                                logoutAndReload()
                                reject(error)
                            }
                        })

                    }else if(err['status'] === 401){
                        const error = new Error("protectedApiCallWithPromise got 401")
                        error.name = "protectedApiCallWithPromise Unauthorized"
                        const contextData = {
                            apicalldata:{
                                function: "protectedApiCallWithPromise",
                                url: url,
                                version: version,
                                method: method,
                                data: JSON.stringify(data),
                                bearer: bearer,
                            }
                        }
                        sentryAPIErrorV2(error, contextData)
                        doneActions()
                        logoutAndReload()
                        reject(err)
                    }else{
                        if ((typeof alertNotification !== "undefined") && (!silent)) {
                            alertNotification(messages.verificationEmail.errorDescription);
                        }
                        doneActions()
                        reject(err)  
                    }
                }else{
                    if ((typeof alertNotification !== "undefined") && (!silent)) {
                        alertNotification(messages.verificationEmail.errorDescription);
                    }
                    doneActions()
                    reject(err)
                }
                
            }
        })
    })
}

export async function protectedApiCallRetry(method, url, data, n){
    try {
        // with no auth or Unhauthorized response, page will reload
        // and no retry is done
        return await protectedApiCallWithPromise(
            method,
            url,
            data
        )
    } catch (error) {
        if (n === 1) throw error;
        await new Promise((resolveFunc) =>
            setTimeout(resolveFunc, 200)
        );
        return await protectedApiCallRetry(method, url, data, n - 1);
    }
}

export function apiCallWithPromise(method, url, dataObject, version){
    let defaultVersion = "v1";
    version = version || defaultVersion;
    return new Promise((resolve, reject) => {
        let epUrl = apiEP(url)
        if (version !== defaultVersion){
            epUrl = switchApiVersion(url, version)
        }
        let data = JSON.stringify(dataObject)
        if (Object.keys(dataObject).length === 0) {
            data = null
        }
        $.ajax({
            method: method,
            headers: {
                "x-client-type": "web",
                "x-client-version": JS_VERSION
            },
            url: epUrl,
            data: data,
            dataType: 'json',
            success: function(data){
                resolve(data)
            },
            error: function(data){
                reject(data)
            }
        })
    })
}

export async function apiCallRetry(method, url, data, n){
    try {
        return await apiCallWithPromise(
            method,
            url,
            data
        )
    } catch (error) {
        if (n === 1) throw error;
        await new Promise((resolveFunc) =>
            setTimeout(resolveFunc, 200)
        );
        return await apiCallRetry(method, url, data, n - 1);
    }
}

export function requestForModalOnNextPage(modalId, modalDataObj) {
    if (modalId.length) {
        Cookies.set(nextModalOpenVar, modalId)
    }
    if (modalDataObj) {
        Cookies.set(nextModalOpenVarData, JSON.stringify(modalDataObj))
    }
}

export function handleTryPremiumContentClick(url) {
    const selector = "#" + tryPremiumModalId
    openModal(selector, 'handleTryPremiumContentClick')
    // set redirect url 
    $(selector).data('afterCheckoutUrl', url);
    return false;
}

export function openModalOnce() {
    let openMod = Cookies.get(nextModalOpenVar);
    const nm = Cookies.get(nextModalOpenVarData)
    let openModData = nm ? JSON.parse(nm) : null
    
    Cookies.remove(nextModalOpenVar);
    Cookies.remove(nextModalOpenVarData)
    if (openModData) {
        if (openModData.notOnPremium) {
            if (Cookies.get('Diane') == "P") return
        }
        $('#' + openMod).data(openModData.key, openModData.value);
    }
    openModal('#' + openMod, 'openModalOnce')
}

export function showSpinner() {
    $(`#${spinnerContainerId}`).addClass("show");
}

export function hideSpinner() {
    $(`#${spinnerContainerId}`).removeClass("show");
}

export function checkNoCards(container) {
    let cards = container.find(CardContainerClass);
    if (cards.length) {
        toggleEmptyCard(false);
        container.removeClass("d-none");
    } else {
        toggleEmptyCard(true);
        container.addClass("d-none");
    }
}

export function checkToDelete(formId, email) {
    const formEl = $("#" + formId);
    const emailField = formEl.find('#emailDelete');
    if (formEl.is(':valid')) {
        if (emailField.val() === email) {
            const u = Cookies.get('User');
            const endpoint = '/users/' + u;
            protectedApiCall('DELETE', endpoint, {},
                function (d) {
                    successNotification(messages.profile.dataCancelled);
                    setTimeout(function () {
                        logoutAndReload()
                    }, 3000);
                },
                function (err) {
                    alertNotification(messages.profile.unableToDeleteData);
                    sentryAPIError(endpoint, err, {}, 'checkToDelete');
                });

        } else {
            alertNotification(messages.profile.mailMismatchError);
        }
    } else {
        alertNotification(messages.profile.pleaseFillInAllFormFields);
    }
}

export function callDatalayer() {
    const cookieName = cookieNames.datalayerBookPush;
    if (!Cookies.get(cookieName)) return false
    const arrayData = JSON.parse(Cookies.get(cookieName))
    
    const toSend = []
    arrayData.forEach((data)=>{
        const isPushedToDataLayer = sendDataLayer(data)
        if (!isPushedToDataLayer) toSend.push(data)

    })
    if (toSend.length == 0){
        Cookies.remove(cookieName)
    }else{
        Cookies.set(cookieName, JSON.stringify(toSend))
    }
}

export function requestDatalayerPushNextPage(data) {
    const cookieName = cookieNames.datalayerBookPush
    let datas = []
    if (Cookies.get(cookieName)) {
        datas = JSON.parse(Cookies.get(cookieName))
    }
    datas.push(data)
    Cookies.set(cookieName, JSON.stringify(datas))
}

export function showUpsellFixedBanner() {
    const alreadyShown = Cookies.get(cookieNames.planUpgradeShown);
    if (!alreadyShown) {
        const el = $(".upsellfixedbanner");
        if (el.length) {
            el.removeClass("d-none");
        }
    }
}

export function doSelectPlan(planId, planClassRef) {
    // selectedPlan is global
    selectedPlan = planId;

    // free trial box
    const noRiskBlockFreeTrial = $(".no-risk-block.free-trial")
    const noRiskBlockNoFreeTrial = $(".no-risk-block.no-free-trial")
    if (allPlans[planId].hasTrial){
        if (noRiskBlockFreeTrial.hasClass('d-none')) noRiskBlockFreeTrial.removeClass('d-none')
        if (!noRiskBlockNoFreeTrial.hasClass('d-none')) noRiskBlockNoFreeTrial.addClass('d-none')
    }else{
        if (noRiskBlockNoFreeTrial.hasClass('d-none')) noRiskBlockNoFreeTrial.removeClass('d-none')
        if (!noRiskBlockFreeTrial.hasClass('d-none')) noRiskBlockFreeTrial.addClass('d-none')
    }
    freeTrialManage(allPlans[planId].trialPeriod)

    // for subscribe page, plan box
    if (planClassRef != ""){
        // box border
        $(".plan-box").removeClass('pricing-promoted').addClass('pricing-not-promoted');
        $("." + planClassRef).removeClass('pricing-not-promoted').addClass("pricing-promoted");
    }
    
    // buttons in identity-block, app-download, try-free-no-risk
    updateBuyButtonCta(allPlans[planId].label)
    updateBuyButtonDescription(allPlans[planId].description)
    

    // update buy-buttons href in identity-block, app-download, try-free-no-risk
    const buyAnchorButtons = $(".to-chk-btn-ref")
    if (buyAnchorButtons.length){
        const newUrl = checkoutLink + allPlans[planId]['chkQueryString']
        buyAnchorButtons.attr('href', newUrl)
    }
}

export function updateBuyButtonCta(text){
    const buttonEls = document.querySelectorAll('.buy-btn-js-selector .inner span')
    buttonEls.forEach((button) => {
        button.innerHTML = text
    });
}

export function updateBuyButtonDescription($text){
    const descriptions = document.querySelectorAll('.msg-js-selector .btn-msg')
    descriptions.forEach((desc) => {
        desc.innerHTML = $text
    });
}

export const persUrl = function (url) {
    const u = UIDg;
    if (u && url) {
        return url.replace('xxx', u);
    }
    return '';
}

export const isMobileOrTablet = function () {
    var e, t = !1;
    return e = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (t = !0), t && (navigator.userAgent.match(/FB/) || navigator.userAgent.match(/Instagram/i) || navigator.userAgent.match(/GSA/i)) && (t = !1), t
};

export function setDoNotShowDl() {
    Cookies.set(cookieNames.doNotShowDlMobile, true, {expires: 7});
}

export function setDoNotShowBanner() {
    Cookies.set(cookieNames.doNotShowBanner, true);
}

export const freeTrialManage = function(days) {
    freeTrialDaysUpdate(days)
    freeTrialFunnelUpdates(days)    
}

// return true after login from the same page
export const isPageReloadedAfterLogin = function(){
    const current = window.location.pathname
    const login = getLoginUrl();
    removeLoginUrl()
    return current === login
}

export const alertNotification = function (text) {
    noty('danger', text);
}

export const dangerNotification = function (text) {
    noty('fixdanger', text);
}

export const successNotification = function (text) {
    noty('success', text);
}

export function setSkillXpLevelBar(){
    const bars = $(".xp-bar")
    bars.each(function(){
        const bar = $(this)       
        const maxXp = parseInt(bar.data("xpmax"))
        let xp = parseInt(bar.data("xp"))
        if (xp > maxXp) xp = maxXp
        const value = xp * 100 / maxXp
        bar.css("flex-basis", value.toString() + "%")
    })
}

export function attachTryPremiumSubscribe(){
    // only for not-verified user
    $(".tryPremiumSubscribeBtn").click(function(e){
        document.getElementById(tryPremiumModalId).addEventListener('hidden.bs.modal', function(){
            reVerifyEmailAndOpenResendPopup(selectedPlan)
        })
        const el = document.getElementById(tryPremiumModalId)
        if (el){
            Modal.getOrCreateInstance(el).hide()
        }
    })

    // verified users, close popup before go to checkout page
    $(".cta-action-attach-clk.try-premim-popup-btn").on('click', function(){
        const el = document.getElementById(tryPremiumModalId)
        if (el){
            Modal.getOrCreateInstance(el).hide()
        }
    })
}

export function manageWelcomeGuestPremium(){
    const modal = $("#CongratsGuestModal")
    document.getElementById('CongratsGuestModal').addEventListener('show.bs.modal', function(){
        if (!modal.data("guestusr")) return
        const user = modal.data("guestusr")
        $("#CongratsGuestModal .usr-mail").text(user)
        document.getElementById('CongratsGuestModal').addEventListener('hidden.bs.modal', function(){
            openSignInModal()
        })
    })
}

export function isMobileCheck(){
    const checkEl = $(".only-mobile-check")
    return checkEl.is(":visible")
}

export function isMobileTabletCheck(){
    const checkEl = $(".mobile-tablet-check")
    return checkEl.is(":visible")
}

export function isMobileUA() {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
}

export function isMobileDimension() {
    return window.matchMedia("(max-width: 768px)").matches;
  
    // -- alternative use --
    // const mq = window.matchMedia("(max-width: 768px)");
    // mq.addEventListener("change", () => {
    //     if (mq.matches) {
    //         // <= 768px
    //     } else {
    //         // > 768px
    //     }
    // });
}

// maybe some touch laptop is included
export function isTouchDevice() {
  return ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
}

export function getUserIdFromHash(hash){
    return hash.split("-")[0]
}

export function websiteUrl() {
    return window.location.protocol + "//" + window.location.host + "/";
}

export function extractCheckoutJwtFromUrl(pageurl){
    const url = new URL(pageurl)
    const param = url.searchParams.get('p')
    return param ? param : ""
}

export function splitJoinedNameAndLastName(joinedName){
    // Replace one or more consecutive whitespace characters 
    // (spaces, tabs, newlines, etc.) with a single space
    const normalized = joinedName.replace(/\s+/g, " ")
    const parts = normalized.split(" ")
    return [...parts.splice(0,1), parts.join(" ")]
}

export function validateUserNameFromEl($inputEl){
    const cleanVal = cleanUserName($inputEl.val())
    return cleanVal.length > 0;

    // // old rules, we want two words
    // const cleanVal = cleanUserName($inputEl.val())
    // const [userFirstNameVal, userLastNameVal] = splitJoinedNameAndLastName(cleanVal)
    // if (!userFirstNameVal || !userLastNameVal) return false
    // return true
}

export function cleanUserName(rawUserName){
    // Replace one or more consecutive whitespace characters 
    // (spaces, tabs, newlines, etc.) with a single space
    const normalized = rawUserName.replace(/\s+/g, " ")
    return normalized.trim()
}

export function showSimpleToast(customIcon, msg, customClass, duration=5000){
    const classString = "<<customClass>>"
    const iconString = "<<customIcon>>"
    let temp = `
    <div class="toast fade ${customClass} `+classString+`" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-wrap">
            <div class="toast-body">
                <div class="warning-icon-wrap">`+iconString+`</div>
                <div>
                    <p class="labelM-med">`+msg+`</p>
                </div>
            </div>
        </div>
    </div>
    `
    let deskTemp = temp.replace(classString, "d-none d-md-block")
    deskTemp = deskTemp.replace(iconString, customIcon)
    const elDesk = $(deskTemp).appendTo('.toast-container.msg-noty.msg-noty-desk')
    const elDeskDom = elDesk[0]

    let mobileTemp = temp.replace(classString, "d-md-none")
    mobileTemp = mobileTemp.replace(iconString, customIcon)
    const elMobile = $(mobileTemp).appendTo('.toast-container.msg-noty.msg-noty-mobile')
    const elMobileDom = elMobile[0]

    Toast.getOrCreateInstance(elDeskDom, {'delay': duration}).show()
    Toast.getOrCreateInstance(elMobileDom, {'delay': duration}).show()
    elDeskDom.addEventListener('hidden.bs.toast', () => {
        elDeskDom.remove()
    })
    elMobileDom.addEventListener('hidden.bs.toast', () => {
        elMobileDom.remove()
    })
}

export const frontendSubscribeLink = $(dataContainerSelector).data("subscribelink")
export const searchLink = $(dataContainerSelector).data("searchlink")
export const checkoutLink = $(dataContainerSelector).data("checkoutlink")
export const bookLink = $(dataContainerSelector).data("booklink")
export const homeLink = $(dataContainerSelector).data("homelink")
export const premiumSubscribeMsg = $(dataContainerSelector).data("premiumsubscribemsg")
export const genericRetryErrMsg = $(dataContainerSelector).data("genericretryerr")
export const signinModalId = $(dataContainerSelector).data("signinmodal")
export const chatbotUrl = $(dataContainerSelector).data("chatboturl")
export const abForNew = $(dataContainerSelector).data("abfornew") == "1"
export const abForVisitor = $(dataContainerSelector).data("abforvisitor") == "1"
export const abEnter = $(dataContainerSelector).data("abpage") == "1"

export const userIsLogged = UIDg ? true : false
// same as UiP
export const userIsPremium = $(dataContainerSelector).data("ispremium")
export const userCanAccessPremiumCont = $(dataContainerSelector).data("capc")
export const userIsVerified = $(dataContainerSelector).data("isverified")
export const userVerifyCode = $(dataContainerSelector).data("verifycode")
export const pageLang = function(){return LL}
export const isWebView = $(dataContainerSelector).data("iswv")
export const alternativeCheckoutLink = $(dataContainerSelector).data("altchk")
export const envType = $(dataContainerSelector).data("env")